import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { useSelector } from 'react-redux'
import { itemIdsToItems } from '../components/item/itemsTransformers'
import {
  displayRecommendedCategories,
  rejectRecommendedCategories,
  acceptRecommendedCategories,
} from './userActions'
import SimpleItem from '../components/item/SimpleItem'
import './categoryRecommendation.pcss'


const CategoryRecommendations = ({ dispatch }) => {
  const category = useSelector(state => state.user.recommendedCategories.get('category'))
  const itemIds = useSelector(state => state.user.recommendedCategories.get('itemsIds'))
  const items = useSelector(state => itemIdsToItems(state, itemIds))
  const categoryId = category.get('id')
  const categoryName = category.get('properName')

  // Count one display occurrence on mount
  useEffect(() => {
    if (!categoryId) return
    dispatch(displayRecommendedCategories(categoryId))
  }, [categoryId, dispatch])

  if (!categoryId) return null

  const handleAccept = () => {
    dispatch(acceptRecommendedCategories(categoryId))
  }

  const handleReject = () => {
    dispatch(rejectRecommendedCategories(categoryId))
  }

  return (
    <div className='recommendations'>
      <div className='recommendations-header'>
        <div className='recommendations-header__title'>
          { `Suosittelemme: ${categoryName}` }
        </div>

        <button
          type='button' className='recommendations-header__accept' onClick={ handleAccept }
          title={ `Seuraa kategoriaa ${categoryName}` } aria-label={ `Seuraa kategoriaa ${categoryName}` }
        >
          <span className='fa fa-check' aria-hidden='true' /> <span aria-hidden='true'>Seuraa</span>
        </button>

        <button
          type='button' className='recommendations-header__reject' onClick={ handleReject }
          title='Hylkää kategoriaehdotus' aria-label='Hylkää kategoriaehdotus'
        >
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
            { /* !Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. */ }
            <path fill='currentColor' d='M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z' />
          </svg>
        </button>
      </div>

      <div className='recommendations-content'>
        <div className='recommendations-content__news'>
          { items.map((item, i) => (
            <SimpleItem
              key={ item.get('id') }
              dispatch={ dispatch }
              item={ item }
              trackingClass='recommended-news'
              gaItemClickUiElement='Kategoriasuositus'
            />
          )) }
        </div>
      </div>
    </div>
  )
}

CategoryRecommendations.propTypes = exact({
  dispatch: PropTypes.func.isRequired,
})

export default CategoryRecommendations
